module.exports = __webpack_public_path__ + "media/images/alice-sm-d733df04d067f04eec54cfb3267c6dfe.jpg";